<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    Icon,
} = UIKit

const { message } = defineProps<{
    isLevelUpQuiz: boolean
    message: string
}>()

</script>

<template>
    <div
        v-dark
        class="quiz-result-header-message"
        :class="{
            'quiz-result-header-message--level-up': isLevelUpQuiz,
        }"
    >
        <div class="quiz-result-header-message__title-header">
            <div
                v-dark
                class="quiz-result-header-message__title"
                :class="{
                    'quiz-result-header-message__title--level-up': isLevelUpQuiz,
                }"
            >
                {{ isLevelUpQuiz ? 'Learning Journey' : 'Recall Challenge' }}
                <Icon
                    v-dark
                    type="highlight"
                    class="quiz-result-header-message__highlight"
                    :class="{
                        'quiz-result-header-message__highlight--level-up': isLevelUpQuiz,
                    }"
                />
            </div>
        </div>
        <div v-dark class="quiz-result-header-message__message">
            {{ message }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.quiz-result-header-message {
    margin-top: -36px;

    &--level-up {
        margin-top: 16px;

        @include breakpoint(black-bear) {
            margin-top: 0;
        }
    }

    &__title {
        color: $brand-black;
        font-size: 26px;
        font-weight: 600;
        line-height: 34px;
        position: relative;

        &--dark {
            color: $white;
        }

        @include breakpoint(brown-bear) {
            text-align: center;
            font-size: 20px;
            line-height: 27px;
            margin-top: 32px;
        }

        &--level-up {
            @include breakpoint(black-bear) {
                margin-top: 28px;
            }
        }
    }

    &__highlight {
        position: absolute;
        left: -4px;
        bottom: -7px;
        color: $pearl;
        width: 216px;
        height: 24px;
        flex-shrink: 0;
        z-index: -1;

        &--dark {
            color: $pickled-bluewood;
        }

        &--level-up {
            width: 222px;
        }

        @include breakpoint(brown-bear) {
            display: none;
        }
    }

    &__message {
        width: 496px;
        color: $brand-black;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        margin-top: 16px;

        &--dark {
            color: $fog
        }

        @include breakpoint(brown-bear) {
            text-align: center;
        }

        @include breakpoint(black-bear) {
            width: 291px;
            margin-bottom: 40px;
        }
    }
}
</style>
